import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

import { DATE_FORMAT_TIME } from '../../utils/constants';

interface PropTypes {
  time: Date | null | undefined;
}

export default function displayTime({ time }: PropTypes): JSX.Element {
  const timeString = time ? moment(time).format(DATE_FORMAT_TIME) : '';
  return <Container>{timeString}</Container>;
}

const Container = styled.div`
  margin: 0 3px;
  padding: 3px 6px;
  background: #f4f4f4;
  border-radius: 3px;
  font-size: 18px;
  font-weight: 500;
  width: fit-content;
`;